import { defineStore, getActivePinia } from 'pinia'

import type { GaApp } from '~/modules/app'

import { getters } from './getters'
import { state } from './state'

export const userStore = (gaApp: GaApp) => {
  const init = defineStore('user', {
    getters: getters(gaApp),
    state,
  })

  return init(getActivePinia())
}
